// extracted by mini-css-extract-plugin
module.exports = {"Inputs":"Form_Inputs__2PI6I"};